import React from "react";
import "./Header.scss";
import { images } from "../../constant";
import { motion } from "framer-motion";
import{AppWrap} from '../../wrapper'
const ScaleVariant = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

function Header() {
  return (
    <div className="app__header app__flex">
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className="app__header-info"
      >
        <div className="app__header-badge">
          <div className="badge-cmp app__flex">
            <span>👋</span>
            <div style={{ marginLeft: 20 }}>
              <p className="p-text"> Hello,I am</p>
              <h1 className="head-text"> Kodiyarasu</h1>
            </div>
          </div>
          <div className="tag-cmp p__flex">
            <p className="p-text">FrontEnd Developer</p>
            <p className="p-text">MERN Stack Developer</p>
          </div>
          <div className="app__header-resume">
           <a className='p-text' href="https://drive.google.com/file/d/14awPYiUKux-je0es1cjj8LDC4XWV9N89/view?usp=sharing" target="blank">Resume</a>
          </div>
        </div>
      </motion.div>

      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className="app__header-img"
      >
        <img src={images.profile1} alt="profile_img"></img>
        <motion.img
          whileInView={{ scale: [0, 1] }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          src={images.circle}
          alt="profile-circle"
          className="overlay_circle"
        />
      </motion.div>

      <motion.div
        variant={ScaleVariant}
        whileInView={ScaleVariant.whileInView}
        className="app__header-circles">
        {[images.react, images.redux, images.sass].map((circle, index) => (
          <div className="circle-cmp app__flex" key={`circle-${index}`}>
            <img src={circle} alt="circle" />
          </div>
        ))}
      </motion.div>
    </div>
  );
}

export default AppWrap(Header,'home');
